var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneMissed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_490",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "matrix(-1 0 0 1 14 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0169 11.9002L13.3586 10.5877C13.4752 10.471 13.5336 10.3349 13.5336 10.1793C13.5336 10.0238 13.4752 9.88766 13.3586 9.771C12.503 8.84738 11.5162 8.15468 10.3982 7.69287C9.2801 7.23107 8.14746 7.00016 7.00024 7.00016C5.85301 7.00016 4.72281 7.23107 3.60961 7.69287C2.49642 8.15468 1.50718 8.84738 0.641903 9.771C0.525236 9.88766 0.466904 10.0238 0.466904 10.1793C0.466904 10.3349 0.525236 10.471 0.641903 10.5877L1.98357 11.9002C2.09051 12.0071 2.21447 12.0654 2.35544 12.0752C2.49642 12.0849 2.62524 12.046 2.7419 11.9585L4.43357 10.6752C4.51135 10.6168 4.56968 10.5488 4.60857 10.471C4.64746 10.3932 4.6669 10.3057 4.6669 10.2085V8.546C5.03635 8.42933 5.41551 8.33697 5.8044 8.26891C6.19329 8.20086 6.5919 8.16683 7.00024 8.16683C7.40857 8.16683 7.80718 8.20086 8.19607 8.26891C8.58496 8.33697 8.96412 8.42933 9.33357 8.546V10.2085C9.33357 10.3057 9.35301 10.3932 9.3919 10.471C9.43079 10.5488 9.48912 10.6168 9.5669 10.6752L11.2586 11.9585C11.3752 12.046 11.5041 12.0849 11.645 12.0752C11.786 12.0654 11.91 12.0071 12.0169 11.9002ZM7.0294 6.621L9.9169 3.7335V5.25016H11.0836V1.75016H7.58357V2.91683H9.10024L7.04399 4.97308L3.74815 1.67725L2.9169 2.5085L7.0294 6.621Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMissed);
export default __webpack_public_path__ + "static/media/phone_missed.b002077885a6269a558ccf967e5c1586.svg";
export { ForwardRef as ReactComponent };